import { render, staticRenderFns } from "./orders.vue?vue&type=template&id=3a6975f2&scoped=true"
import script from "./orders.vue?vue&type=script&lang=js"
export * from "./orders.vue?vue&type=script&lang=js"
import style0 from "./orders.vue?vue&type=style&index=0&id=3a6975f2&prod&scoped=true&lang=scss"
import style1 from "./orders.vue?vue&type=style&index=1&id=3a6975f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6975f2",
  null
  
)

export default component.exports